import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, takeUntil } from 'rxjs';
import {
  RepoPosition

} from '../../models/repo-business/repo-business.model';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { RepoBusinessService } from '../../shared-new/services/repo-business.service';
import { PositionEditComponent } from '../position-edit/position-edit.component';

@Component({
  selector: 'app-position-org-popup',
  templateUrl: './position-org-popup.component.html',
  styleUrls: ['./position-org-popup.component.scss']
})
export class PositionOrgPopupComponent extends BaseUnsubscribeComponent implements OnInit {
  @Input() isViewMode: boolean = true;
  public position: RepoPosition;
  @Input() public positions$: Observable<RepoPosition[]>;
  positions: RepoPosition[] = [];
  public searchTerm: string = '';
  @ViewChild('positionEdit') positionEdit: PositionEditComponent;
  constructor(
    public readonly modal: NgbActiveModal, private readonly repoBusinessService: RepoBusinessService
  ) {
    super();
  }

  public positionSaved(position: RepoPosition): void {
    this.isViewMode = true;
  }
  public positionValidationFailed(contact: RepoPosition) {
  }
  public dismissPopup(): void {
    this.modal.dismiss(JSON.stringify(this.position));
  }
  public AddPosition() {
    this.isViewMode = false;
    this.position = { positionId: 0 } as RepoPosition;
  }
  public EditRepoPosition(position: RepoPosition) {
    this.repoBusinessService.getPositionById(position.positionId).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      this.isViewMode = false;
      this.position = response;
    });
  }

  public ngOnInit(): void {
    this.positions$.pipe(takeUntil(this.unsubscribe$)).subscribe((positions) => {
      this.positions = positions;
    });
  }

  public savePosition() {
    this.positionEdit?.submitForm();
  }

}
